<script setup lang="ts">
import { ref } from 'vue';

defineProps<{
  title: string;
  content: string;
}>();

const show = ref(false);
</script>

<template>
  <div class="relative inline-block">
    <!-- Icône d'aide -->
    <button
      @mouseenter="show = true"
      @mouseleave="show = false"
      @focus="show = true"
      @blur="show = false"
      class="
        ml-1
        text-gray-400
        hover:text-primary-600
        dark:hover:text-primary-400
        transition-colors
        duration-150
        cursor-help
      "
      type="button"
      :aria-label="'Aide : ' + title"
    >
      <fa :icon="['far', 'question-circle']" class="text-xs" />
    </button>

    <!-- Tooltip -->
    <Transition name="tooltip">
      <div
        v-if="show"
        class="
          absolute
          bottom-full
          left-1/2
          transform
          -translate-x-1/2
          mb-2
          z-50
          w-64
          px-3
          py-2
          bg-gray-900
          dark:bg-gray-700
          text-white
          text-xs
          rounded-lg
          shadow-lg
          pointer-events-none
        "
      >
        <div class="font-semibold mb-1">{{ title }}</div>
        <div class="text-gray-300">{{ content }}</div>

        <!-- Flèche -->
        <div
          class="
            absolute
            top-full
            left-1/2
            transform
            -translate-x-1/2
            w-0
            h-0
            border-l-4
            border-r-4
            border-t-4
            border-transparent
            border-t-gray-900
            dark:border-t-gray-700
          "
        ></div>
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.tooltip-enter-active,
.tooltip-leave-active {
  transition: opacity 0.2s ease;
}

.tooltip-enter-from,
.tooltip-leave-to {
  opacity: 0;
}
</style>

